/*
 * @Author: 冯杰
 * @Date: 2021-09-03 15:37:44
 * @LastEditTime: 2021-09-03 15:38:47
 * @FileName: 红包余额看板
 */
import Balance from './balance.vue';

export default Balance;
